import classes from 'components/App/AuthPublicPages/_common/LoginComponent/CredentialsForm/credentialsForm.module.scss';
import { CustomizedFormErrorMessage } from 'components/common';
import { NavLink } from 'react-router-dom';
import { Control, Controller, UseFormHandleSubmit, UseFormRegister } from 'react-hook-form';
import { PasswordInput } from 'components/common/passwordInput/passwordInput';
import React from 'react';
import { NewButton } from 'components/common/CustomizeButton/newButton';
import { ILoginForm } from 'components/App/AuthPublicPages/Login/login';
import { FieldErrors } from 'react-hook-form/dist/types/errors';

interface Props {
    title: string;
    handleSubmit: UseFormHandleSubmit<ILoginForm>;
    login: (data: ILoginForm) => void;
    errors: FieldErrors<ILoginForm>;
    register: UseFormRegister<ILoginForm>;
    control: Control<ILoginForm>;
    error?: string;
    isLoading: boolean;
}

export const CredentialsForm = ({ handleSubmit, login, errors, register, control, error, isLoading }: Props) => {
    return (
        <form onSubmit={handleSubmit(login)} data-testid={'credentials-form'}>
            <div className={classes.formWrapper}>
                <div className={classes.inputsContainer}>
                    <div className={classes.inputWrapper}>
                        <label>E-mail</label>
                        <input
                            className={`${errors.username ? classes.invalid : ''} ${classes.loginInput}`}
                            id="username"
                            {...register('username', {
                                required: 'Email is required',
                            })}
                            type="email"
                            placeholder={'E-mail'}
                        />
                        {errors.username && <CustomizedFormErrorMessage text={errors.username.message} />}
                    </div>
                    <div className={classes.inputWrapper}>
                        <div className={classes.passwordLabelWrapper}>
                            <label>Password</label>
                            <NavLink to={'/forgotpassword'}>Forgot Your Password?</NavLink>
                        </div>
                        <Controller
                            render={({ field }) => (
                                <PasswordInput
                                    className={`${errors.password ? classes.invalid : ''} ${classes.loginInput}`}
                                    {...field}
                                    placeholder={'Password'}
                                    id={'password'}
                                />
                            )}
                            name={'password'}
                            rules={{ required: 'Password is required' }}
                            control={control}
                        />
                        {errors.password && <CustomizedFormErrorMessage text={errors.password.message} />}
                        {error && <CustomizedFormErrorMessage text={error} />}
                    </div>
                </div>
                <div className={classes.actionsWrapper}>
                    <NewButton
                        color="login"
                        variant="contained"
                        className={classes.submit}
                        disabled={isLoading}
                        loading={isLoading}
                        id="login-button"
                        type={'submit'}
                    >
                        Sign in
                    </NewButton>
                </div>
            </div>
        </form>
    );
};
